<div class="grid">
  <div class="sm:col-12 md:col-6 lg:col-6 xl:col-5 m-auto pt-8 mt-6">
    <div class="card mb-4">
      <div class="surface-card p-2 md:p-8 md:shadow-2 border-round w-full mt-4">
        <div class="text-center mb-8">
          <div class="inline-block bg-primary mb-8 p-2">
            <img src="/assets/img/tlogo4.svg" alt="Image" width="205" height="51">
          </div>
          <div class="text-600 text-2xl font-medium line-height-3">Login to access Touchstone Institute Portal</div>
          <div class="mt-4 text-center">
            <span class="text-600 font-medium line-height-3">Click on a service to continue</span>
          </div>
          <div class="flex mt-4 gap-3 justify-content-center">
            <p-button label="PRACTICE READY ONTARIO" [style]="{ 'font-size': '0.9rem' }" pRipple icon="pi pi-user" routerLink="/login/pro" severity="primary" />
            <p-button label="PRP & CMP" pRipple icon="pi pi-user" routerLink="/login/learning" severity="primary" />
            <p-button label="EXAM" pRipple icon="pi pi-user" routerLink="/login/exam" severity="primary" />
            <!-- <button class="p-button-lg bg-primary" routerLink="/login" ></button> -->
          </div>
        </div>
        <!-- <div class="mt-7 text-center">
          <span class="text-600 font-medium line-height-3">If you have an activation code,</span>
          <a routerLink="/auth/code-activation" class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">click
            here</a>
        </div> -->
        <!-- <div class="mt-4 text-center">
          <a routerLink="/create-account/pro" class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Click
            here </a>
          <span class="text-600 font-medium line-height-3">to create an account without an activation
            code</span>
        </div> -->
      </div>

    </div>

  </div>
</div>
